import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { EventsFlowEventNodeTypes } from '../../models/events-flow-event-node-types';
import { INodeStaticMapItem } from '../i-node-static-map-item';
import { IFlowViewModel } from '../../../../core/visual/work-flow-editor/models/i-flow-view-model';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, Subscription } from 'rxjs';
import { WORKFLOW_EVENTS } from './workflow-events-constant';
import { FlexModule } from '@angular/flex-layout';
import { NgIf, NgFor } from '@angular/common';
import { MatTextInputComponent } from '../../../../editors/mat-text-input/mat-text-input.component';
import { FExternalItemDirective } from '@foblex/flow';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-workflow-palette-events',
    templateUrl: './workflow-palette-events.component.html',
    styleUrls: ['./workflow-palette-events.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        FlexModule,
        NgIf,
        MatTextInputComponent,
        FormsModule,
        ReactiveFormsModule,
        NgFor,
        FExternalItemDirective,
        MatTooltip,
        MatIcon,
    ],
})
export class WorkflowPaletteEventsComponent implements OnInit, OnDestroy {
  @Input({ required: true })
  public viewModel!: IFlowViewModel<any>;

  @Output()
  public readonly eventClicked = new EventEmitter<INodeStaticMapItem>();

  public filteredEvents: INodeStaticMapItem[] = [];

  public readonly searchControl = new FormControl();
  public readonly events = WORKFLOW_EVENTS;

  private readonly _subscriptions = new Subscription();

  constructor(private readonly _cdr: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.filteredEvents = [...this.events];

    this._subscriptions.add(this.subscribeSearch());
  }

  public ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  private subscribeSearch(): Subscription {
    return this.searchControl.valueChanges.pipe(debounceTime(300)).subscribe((data: string) => {
      this.filteredEvents = this.events.filter(event => event.name.toLowerCase().includes(data?.toLowerCase() || ''));
      this._cdr.detectChanges();
    });
  }
}
